<template>
    <div>
        <div class="row">

            <div class="wrap-right col-md-8">
                <div class="full-width">
                    <embed :src="apiUrl + dataDetailExcercise.path" class="ember-pdf" />
                </div>
            </div>
            <div v-if="!this.isShowResult" class="wrap-left col-md-4">
                <div v-if="isSubmitExcercise" class="text-center"><strong>Còn lại {{ formatTime() }}</strong></div>
                <div class="list-question-number margin-top-10">
                    <div class="row">
                        <div @click="handleClickQuestion(item)"
                            :class="{ 'is-choose': item == itemSelected && !item.isCheck, 'is-check': item.isCheck, 'is-fill': item.answer && !item.isCheck }"
                            class="col-md-2 question-item-number" v-for="(item, index) of this.dataUserWork"
                            :key="index">
                            {{ item.questionNumber }}
                        </div>

                    </div>
                    <div class="row col-md-12 margin-top-10">
                        <span class="question-name"><strong>Câu {{ itemSelected.questionNumber }}:</strong></span>
                        &nbsp;
                        &nbsp;
                        <a v-if="isSubmitExcercise" @click="handleCheckItem" href="javascript:;"
                            class="item btn btn-check border-rd-20 font-size-16">
                            Đánh dấu
                        </a>
                        &nbsp;
                        &nbsp;
                        <span class="status-save-data" v-if="isSaveData && statusSave == 2">
                            Đang lưu ...
                        </span>
                        <span class="status-save-data" v-if="statusSave == 3">
                            Đã lưu
                        </span>
                    </div>
                    <div class="row col-md-12">
                        <b-form-textarea v-if="dataDetailExcercise.typeUploadExcercise == 5" @input="handleChangeAnswer"
                            id="textarea" v-model="itemSelected.answer" class="margin-top-10"
                            placeholder="Nhập câu trả lời tại đây.." rows="3"></b-form-textarea>
                        <EditorCKNew :disabled="!isSubmitExcercise" v-else class="margin-top-10"
                            @onEditorChange="onEditorChangeAnswer" :contentEditor="itemSelected.answer"
                            :position="'1'" />
                    </div>
                    <div v-if="isSubmitExcercise" :disabled="isSaveData && statusSave == 2" @click="handSubmitExcercise"
                        class="row col-md-12">
                        <a href="javascript:;"
                            class="item btn btn-main border-rd-20 font-size-16 display-flex-center item__add margin-top-10 col-md-12">
                            Nộp bài
                        </a>
                    </div>

                </div>
            </div>
            <div v-else class="wrap-right col-md-4">
                <div v-if="dataDetailExcercise.typeUploadExcercise == 5">
                    <div class="row">
                        <div class="col-md-12 text-center">
                            <h5 v-if="!this.isShowResult">Thông tin đề</h5>
                        </div>
                        <div class="col-md-12 text-center">
                            <strong>Điểm</strong>

                        </div>
                        <div class="col-md-12 text-center">
                            <strong class="result-point">{{ formatNumber(userExcerciseClassSchool.point) }}</strong>
                        </div>
                        <div class="col-md-12 ">
                            <div class="display-flex justify-content-space-between">
                                <div class="title-complete">
                                    <strong>Thời gian hoàn thành</strong>
                                </div>
                                &nbsp;
                                &nbsp;
                                <div class="time-complete">
                                    {{ formatTimeResult() }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <span class="color-blue"></span> Số câu đúng: {{ countQuestionTrue }}
                        </div>
                        <div class="col-md-12">
                            <span class="color-red"></span> Số câu sai: {{ countQuestionFalse }}
                        </div>

                    </div>
                    <div class="list-result-number margin-top-10">
                        <div class="row">
                            <div class="col-md-3 result-item-number"
                                v-for="(item, index) of listUserExcerciseAnswerQuestion" :key="index">
                                <span class="result-number">{{ index + 1 }}.</span>
                                &nbsp;
                                <span class="result-user-fill"
                                    v-html="item.answerUserFill == item.answerContent ? '' : item.answerUserFill.toUpperCase()"></span>
                                &nbsp;
                                <span class="result-answer">
                                    {{ item.answerContent ? item.answerContent.toUpperCase() :
                                    item.feedback.toUpperCase()}}
                                    &nbsp;
                                    <!-- thêm dấu check sau câu đúng -->
                                    <img v-if="item.answerUserFill == item.answerContent" src="@/assets/img/check.png"
                                        class="icon-check" alt /></span>
                            </div>

                        </div>

                    </div>
                </div>
                <div v-else>
                    <div class="row">
                        <div class="col-md-12 text-center">
                            <h5 v-if="!this.isShowResult">Thông tin đề</h5>
                        </div>
                        <div class="row col-md-12 wrap-point-feedback display-flex">
                            <div class="col-md-4 text-center">
                                <strong>Tổng điểm</strong>

                            </div>
                            <div class="col-md-8">
                                <strong class="result-point">{{ formatNumber(userExcerciseClassSchool.point) }}</strong>
                            </div>
                            <!-- <div @click="handleShowMoreInfo" class="col-md-12 text-end show-more">
                                {{!isShowMoreInfo?'Hiện thêm':'Ẩn bớt'}} <img class="icon-show-more" width="15px" src="@/assets/img/show-more-down.png" />
                            </div> -->
                            <b-collapse class="row col-md-12" :visible="isShowMoreInfo">
                                <div class="col-md-12 font-size-13">
                                    Lời phê:
                                </div>
                                <div class="col-md-12 wrap-feedback-teacher">
                                    <strong v-html="userExcerciseClassSchool.feedback"></strong>
                                </div>
                                <p></p>
                                <!-- <div class="col-md-12">
                                    <span class="font-size-13">Số câu đúng: </span><strong>{{ countQuestionTrue
                                        }}</strong>
                                </div>
                                <div class="col-md-12">
                                    <span class="font-size-13">Số câu sai: </span><strong>{{ countQuestionFalse
                                        }}</strong>
                                </div> -->
                                <div class="col-md-12">
                                    <span class="font-size-13">Thời gian hoàn thành: </span><strong>{{
                                        formatTimeResult() }}</strong>
                                </div>
                            </b-collapse>
                        </div>
                    </div>
                    <div class="row wrap-list-question">
                        <div @click="handViewInfo(item, index + 1)" :class="{ 'is-choose': itemSelected.id == item.id }"
                            class="col-md-2 question-item-number"
                            v-for="(item, index) of listUserExcerciseAnswerQuestion" :key="index">
                            {{ index + 1 }}
                        </div>
                    </div>
                    <div v-if="itemSelected.id" class="row margin-top-10">
                        <div class="col-md-12">
                            <h5>Câu {{ itemSelected.numberQuestion }}: {{ formatNumber(itemSelected.pointTeacherFill)
                                }}/{{
                                    formatNumber(itemSelected.maxPoint) }} điểm</h5>
                        </div>
                        <strong>Câu trả lời học sinh:</strong>
                        <div class="wrap-answer col-md-12">
                            <div v-if="itemSelected.answerUserFill" class="fit-max-height"
                                v-html="itemSelected.answerUserFill">

                            </div>
                            <div v-else>
                                Học sinh chưa trả lời câu hỏi này.
                            </div>
                            <div class="answer-item">

                            </div>

                        </div>
                        <p></p>
                        <strong class="feed-back-teacher-item">Nhận xét giáo viên:</strong>
                        <div class="wrap-answer ">
                            <div v-if="itemSelected.feedback" class="fit-max-height" v-html="itemSelected.feedback">

                            </div>
                            <div v-else>
                                Giáo viên không nhận xét câu trả lời này.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ModalSubmitExcercise :textNotitySubmit="textNotitySubmit" v-if="isOpenModalSubmitExcercise"
            @handleSubmit="handleSubmit" @closeModal="closeModalSubmitExcercise" />

        <ModalSuccessExcercise v-if="isOpenModalSuccessExcercise" @closeModal="closeModalSuccessExcercise" />
        <ModalTimeOutExcercise v-if="isOpenModalTimeOutExcercise" @closeModal="closeModalTimeOutExcercise" />
    </div>
</template>

<script>
import { saveUserExcerciseClassSchool, submitExcercisePdf } from './../../../_api/userExcerciseClassSchool';
import { APP_CONFIG } from '@/utils/constants'
import ModalSubmitExcercise from './ModalSubmitExcercise'
import ModalSuccessExcercise from './ModalSuccessExcercise'
import EditorCKNew from '@/components/EditorCKNew.vue'
import ModalTimeOutExcercise from './ModalTimeOutExcercise'
export default {
    components: {
        ModalSubmitExcercise,
        ModalSuccessExcercise,
        EditorCKNew,
        ModalTimeOutExcercise
    },
    props: {
        dataDetailExcercise: {
            type: Object,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: {}
        },
        userExcerciseClassSchool: {
            type: Object,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: {}
        },
        listUserExcerciseAnswerQuestion: {
            type: Array,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: []
        }

    },
    data() {
        return {
            isShowMoreInfo: true,
            isOpenModalSubmitExcercise: false,
            isOpenModalSuccessExcercise: false,
            isOpenModalTimeOutExcercise: false,
            isSubmitExcercise: true,
            dataUserWork: [],
            apiUrl: APP_CONFIG.appUrl + 'lessons/',
            itemSelected: {},
            secondTotal: 0,
            textNotitySubmit: '',
            isShowResult: false,
            countQuestionTrue: 0,
            countQuestionFalse: 0,
            myInterval: null,
            isSaveData: false,
            statusSave: 1,
            myIntervalAutoSave: null,
            dem: 3
        }
    },
    mounted() {
        this.updateDataPage()
        this.saveDataInterval()
    },
    methods: {
        formatNumber(value) {
            if (typeof value !== 'number') {
                return value;
            }
            return value.toFixed(2);
        },
        handViewInfo(item, index) {
            this.itemSelected = item
            this.itemSelected.numberQuestion = index
            //lấy ra điểm số max của câu này
            for (let i = 0; i < this.dataDetailExcercise.listExcerciseQuestionClassSchool.length; i++) {
                const element = this.dataDetailExcercise.listExcerciseQuestionClassSchool[i];
                if (element.id == this.itemSelected.excerciseQuestionId) {
                    this.itemSelected.maxPoint = element.point
                    break
                }
            }
        },
        handleShowMoreInfo() {
            this.isShowMoreInfo = !this.isShowMoreInfo
        },
        handleChangeAnswer() {
            if (!this.isSubmitExcercise) {
                return
            }
            this.dem = 3
            this.statusSave = 2
            this.isSaveData = true
        },
        onEditorChangeAnswer(e) {
            this.itemSelected.answer = e.html
            this.handleChangeAnswer()
        },
        saveDataInterval() {
            let self = this
            this.myIntervalAutoSave = setInterval(() => {
                self.dem--
                if (self.dem == 0 && self.isSaveData) {
                    self.dem = -1
                    console.log('Lưu data')
                    let dataSend = [...self.dataUserWork]
                    let listDataSave = []
                    for (let i = 0; i < dataSend.length; i++) {
                        const item = dataSend[i];
                        item.answer = item.answer.trim().toLowerCase()
                        if (item.answer) {
                            listDataSave.push(item)
                        }
                    }
                    let timeSubmit = (self.dataDetailExcercise.minuteExcercise * 60) - self.secondTotal

                    let params = {
                        type: 1,
                        lessonClassSchoolId: self.dataDetailExcercise.id,
                        classSchoolId: self.userExcerciseClassSchool.classSchoolId,
                        userExcercisId: self.userExcerciseClassSchool.id,
                        typeUploadExcercise: self.dataDetailExcercise.typeUploadExcercise,
                        listDataUserWorkPdf: listDataSave,
                        timeSubmit: timeSubmit
                    }
                    submitExcercisePdf(params).then((res) => {
                        self.statusSave = 3
                        self.isSaveData = false
                    })
                }
            }, 1000)
        },
        updateDataPage() {
            this.isOpenModalSubmitExcercise = false
            this.isOpenModalSuccessExcercise = false
            this.isSubmitExcercise = true
            this.dataUserWork = []
            this.itemSelected = {}
            this.secondTotal = 0
            this.textNotitySubmit = ''
            this.isShowResult = false
            this.countQuestionTrue = 0
            this.countQuestionFalse = 0
            if (this.userExcerciseClassSchool.status == 2 || this.userExcerciseClassSchool.status == 5) {
                //hiển thị thông tin 
                this.isShowResult = true
                for (let i = 0; i < this.listUserExcerciseAnswerQuestion.length; i++) {
                    const item = this.listUserExcerciseAnswerQuestion[i];
                    if (item.isTrue) {
                        this.countQuestionTrue++
                    }
                    else {
                        this.countQuestionFalse++
                    }
                    if (i == 0) {
                        this.handViewInfo(item, i + 1)
                    }
                }

            } else {
                this.isShowResult = false
                this.initDataUserWork()
                //trường hợp đang đợi chấm thì thôi 
                if (this.userExcerciseClassSchool && this.userExcerciseClassSchool.status > 0) {
                    this.isSubmitExcercise = false
                    return
                }
                if (this.userExcerciseClassSchool) {
                    let datetimeStartDoWork = new Date(this.userExcerciseClassSchool.timeStartDoExcercise)

                    let timeDiff = new Date(this.userExcerciseClassSchool.timeCurrent).getTime() - datetimeStartDoWork.getTime();

                    let secondsDiff = timeDiff / 1000;
                    if (secondsDiff > this.dataDetailExcercise.minuteExcercise * 60) {
                        console.log('Hết thời gian')
                        //this.isSubmitExcercise = false
                    }
                    else {
                        this.secondTotal = (this.dataDetailExcercise.minuteExcercise * 60) - parseInt(secondsDiff)

                        this.initInterval()
                    }
                }
                else {
                    this.isSubmitExcercise = false
                    this.$router.push('/')
                }
            }
        },
        closeModalSuccessExcercise() {
            this.isOpenModalSuccessExcercise = false
        },
        closeModalSubmitExcercise() {
            this.isOpenModalSubmitExcercise = false
        },
        closeModalTimeOutExcercise() {
            this.isOpenModalTimeOutExcercise = false
            this.$emit('handleReloadDetailData')
        },
        handleSubmit(isSaveAuto) {
            this.closeModalSubmitExcercise()
            let self = this
            //format câu trả lời
            for (let i = 0; i < this.dataUserWork.length; i++) {
                const item = this.dataUserWork[i];
                item.answer = item.answer.trim().toLowerCase()
            }
            let timeSubmit = (this.dataDetailExcercise.minuteExcercise * 60) - this.secondTotal

            let params = {
                type: 2,
                lessonClassSchoolId: this.dataDetailExcercise.id,
                classSchoolId: this.userExcerciseClassSchool.classSchoolId,
                userExcercisId: this.userExcerciseClassSchool.id,
                typeUploadExcercise: this.dataDetailExcercise.typeUploadExcercise,
                listDataUserWorkPdf: this.dataUserWork,
                timeSubmit: timeSubmit
            }
            submitExcercisePdf(params).then((res) => {
                if (!isSaveAuto) {
                    self.$toast.success('Nộp bài thành công')
                    self.$emit('handleReloadDetailData')
                }
            })
        },

        handSubmitExcercise() {
            //kiểm tra
            let isFillAllAnswer = true
            for (let i = 0; i < this.dataUserWork.length; i++) {
                const item = this.dataUserWork[i];
                if (!item.answer) {
                    isFillAllAnswer = false
                    break
                }
            }
            if (isFillAllAnswer) {
                this.textNotitySubmit = 'Bạn có chắc chắn muốn nộp bài'
            }
            else {
                this.textNotitySubmit = 'Hiện vẫn còn 1 số câu chưa làm. Bạn có chắc chắn muốn nộp bài luôn?'
            }
            this.isOpenModalSubmitExcercise = true
        },
        formatTimeResult() {
            let hours = Math.floor(this.userExcerciseClassSchool.timeComplete / 3600); // Lấy phần nguyên khi chia cho 3600
            let minutes = Math.floor((this.userExcerciseClassSchool.timeComplete % 3600) / 60); // Lấy phần nguyên của phần dư khi chia cho 3600, sau đó chia cho 60
            let seconds = this.userExcerciseClassSchool.timeComplete % 60;

            if (hours > 0) {
                return `${hours} giờ ${minutes} phút ${seconds < 10 ? `0${seconds}` : `${seconds}`} giây`;
            } else if (minutes > 0) {
                return `${minutes} phút ${seconds < 10 ? `0${seconds}` : `${seconds}`} giây`;
            } else {
                return `${seconds} giây`;
            }
        },
        formatTime() {
            let minutes = Math.floor(this.secondTotal / 60); // Lấy phần nguyên khi chia cho 60
            let seconds = this.secondTotal % 60;
            if (minutes > 0) {
                return `${minutes}:${seconds}`
            }
            return `${seconds}`
        },
        initInterval() {
            let self = this
            this.myInterval = setInterval(() => {
                this.secondTotal--
                if (this.secondTotal <= 0) {
                    this.isSubmitExcercise = false
                    clearInterval(self.myInterval)
                    ///
                    this.handleSubmit(true)
                    this.isOpenModalTimeOutExcercise = true
                }
            }, 1000)
        },
        updateIsCheckQuestion() {
            let listCheck = []
            for (let i = 0; i < this.dataUserWork.length; i++) {
                const item = this.dataUserWork[i];
                listCheck.push(item.isCheck ? 1 : 0)
            }

            let params = {
                statusId: 2,
                lessonClassSchoolId: this.userExcerciseClassSchool.lessonClassSchoolId,
                classSchoolId: this.userExcerciseClassSchool.classSchoolId,
                listCheckQuestion: listCheck.join(',')
            }
            saveUserExcerciseClassSchool(params).then((res) => {
                if (res && res.data && !res.errors) {
                    console.log(res.data)
                }
            })
        },
        handleCheckItem() {
            for (let i = 0; i < this.dataUserWork.length; i++) {
                const item = this.dataUserWork[i];
                if (item == this.itemSelected) {
                    // code cũ
                    // item.isCheck = true
                    // code mới -> click lần 2 thì bỏ đánh dấu
                    item.isCheck = !item.isCheck
                }
            }
            this.updateIsCheckQuestion()
        },
        handleClickQuestion(item) {
            //clear choose old
            this.itemSelected = item
        },
        beforeDestroy() {
            if (this.myInterval) {
                clearInterval(this.myInterval)
            }
            if (this.myIntervalAutoSave) {
                clearInterval(this.myIntervalAutoSave)
            }
        },
        initDataUserWork() {
            let listStringIsCheck = ''
            if (this.userExcerciseClassSchool) {
                listStringIsCheck = this.userExcerciseClassSchool.listCheckQuestion
            }

            let listCheck = []
            if (listStringIsCheck) {
                let arrayTemp = listStringIsCheck.split(',')
                for (let i = 0; i < arrayTemp.length; i++) {
                    listCheck.push(Number(arrayTemp[i]) == 1 ? true : false)

                }
            }
            for (let i = 0; i < this.dataDetailExcercise.listExcerciseQuestionClassSchool.length; i++) {
                const item = this.dataDetailExcercise.listExcerciseQuestionClassSchool[i]
                this.dataUserWork.push({
                    excerciseQuestionClassSchoolId: item.id,
                    questionNumber: i + 1,
                    isCheck: listCheck.length > 0 ? listCheck[i] : false,
                    answer: ''
                })

            }

            // update thông tin nếu user đã điền trước đó
            for (let i = 0; i < this.listUserExcerciseAnswerQuestion.length; i++) {
                const item = this.listUserExcerciseAnswerQuestion[i];
                for (let j = 0; j < this.dataUserWork.length; j++) {
                    const element = this.dataUserWork[j];
                    if (item.excerciseQuestionId == element.excerciseQuestionClassSchoolId) {
                        element.answer = item.answerUserFill
                        break
                    }
                }
            }


            if (this.dataUserWork.length > 0) {
                this.itemSelected = this.dataUserWork[0]
            }
        }
    }

}
</script>

<style lang="scss" scoped>
.fit-max-height {
    min-height: 2rem;
}

.wrap-feedback-teacher {
    max-height: 10rem;
    overflow: auto;
    padding: 10px;
}

.feed-back-teacher-item {
    margin-top: 10px;
}

.wrap-answer {
    border: 1px solid #5f7dcc;
    border-radius: 10px;
    max-height: 10rem;
    overflow: auto;
    padding: 5px;
    min-height: 2rem;
    width: 100%;
}

.margin-top-10 {
    margin-top: 10px
}

.is-true {
    background: #00ac5d !important;
    color: white !important;
    border-radius: 10px;
    text-align: center;
}

.is-false {
    background: #ff4953 !important;
    color: white !important;
    border-radius: 10px;
    text-align: center;
}

.is-choose {
    border: 2px solid blue;
}

.question-item-number {
    width: 100%;
    background: #b7ddf9;
    border-radius: 10px;
    color: blue;
    display: inline-block;
    text-align: center;
    margin-left: 5px;
    margin-top: 10px;
    cursor: pointer;
}

.font-size-13 {
    font-size: 13px;
}

.show-more {
    text-align: end;
    color: #5270e9;
    cursor: pointer;
}

.wrap-point-feedback {
    border: 1px solid gray;
    margin-left: 5px;
    border-radius: 15px;
}

.status-save-data {
    color: gray;
    font-size: 14px;
}

.color-blue {
    width: 10px;
    height: 10px;
    display: inline-block;
    background: green;
    border-radius: 20px;
}

.color-red {
    width: 10px;
    height: 10px;
    display: inline-block;
    background: red;
    border-radius: 20px;
}

.is-check {
    background: #ff832b !important;
    color: white !important;
}

.btn-check {
    background: #ff832b;
    color: white;
    line-height: 18px;
}

.is-fill {
    background-color: blue !important;
    color: white !important;
}

.is-choose {
    border: 2px solid blue;
}

.margin-top-10 {
    margin-top: 10px;
}

.list-question-number .question-item-number {
    width: 100%;
    height: 100%;
    background: #b7ddf9;
    border-radius: 10px;
    color: blue;
    display: inline-block;
    text-align: center;
    margin-left: 5px;
    margin-top: 10px;
    cursor: pointer;
}

.full-width {
    width: 100%;
    height: 40rem;
}

.ember-pdf {
    width: 100%;
    height: inherit;
}

.display-flex-center {
    text-align: center;
    align-items: center;
    justify-content: center;
}
</style>
<style lang="scss" scoped>
.title-complete {}

.time-complete {}

.wrap-right .result-point {
    font-size: 50px;
    font-family: ui-monospace;
    font-style: italic;
    color: #ff4953;
}

.list-result-number {
    .result-item-number {
        .result-number {
            color: #2100af;
            font-size: 20px;
            font-weight: 600;
        }

        .result-user-fill {
            color: red;
            font-size: 20px;
            font-weight: 600;
        }

        .result-answer {
            color: green;
            font-size: 20px;
            font-weight: 600;
        }
    }
}

.icon-check {
    width: 18px;
}
</style>